module.exports = __webpack_public_path__ + "static/media/about_armenia_6.e77524b0.jpg";